import { useState } from "react";

/**
 * Pagination reset counter hook
 *
 * Provides a counter to signal pagination resets to the table component.
 * When the counter is incremented, the table component resets to page 1.
 * This is used when filters or search terms change.
 *
 * @returns {Object} Pagination reset state
 * @returns {number} returns.paginationResetCount - Counter value that triggers pagination reset
 * @returns {Function} returns.setPaginationResetCount - Setter to increment the counter
 *
 * @example
 * const { paginationResetCount, setPaginationResetCount } = usePaginationReset();
 *
 * // When filters change, increment to signal reset
 * setPaginationResetCount((prev) => prev + 1);
 */
export const usePaginationReset = () => {
  const [paginationResetCount, setPaginationResetCount] = useState(0);

  return {
    paginationResetCount,
    setPaginationResetCount,
  };
};
